module.exports = __webpack_public_path__ + "assets/java.45f6ff15.svg";